const testimonials = [
  {
    name: "Dr. Linda S.",
    location: "Roseville, MN",
    rating: 5,
    text: "I'm a physician at a St. Paul area hospital and received an invitation to present at a medical conference in Geneva with three weeks notice. My passport had expired. Fast Passport Center processed my renewal in five business days. I presented at the conference and it was a career highlight. Their service was efficient and professional.",
    service: "Passport Renewal",
  },
  {
    name: "The Nguyen Family",
    location: "Roseville, MN",
    rating: 5,
    text: "We received news that family in Vietnam needed us quickly. We hadn't traveled internationally in years and our passports had all expired. Fast Passport Center helped us navigate the renewal process for three family members. They processed our passports within a week. We are so grateful for their help.",
    service: "Family Passport Renewal",
  },
  {
    name: "Michael T.",
    location: "Roseville, MN",
    rating: 5,
    text: "I work in technology and got an opportunity to travel to a product conference in Amsterdam with two weeks notice. My passport had four months left — not enough. Fast Passport Center processed my renewal in four business days. I made the conference and it was excellent. Highly recommend.",
    service: "Emergency Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function RosevilleTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Roseville &amp; North Ramsey County Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Roseville, St. Paul area, and Ramsey County travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}